var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHolidayIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68.003,
    height: 76.004,
    viewBox: "0 0 68.003 76.004",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15677",
    "data-name": "Group 15677",
    transform: "translate(-75.5 -444.498)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_328",
    "data-name": "Subtraction 328",
    d: "M5689,7781h-56a6.006,6.006,0,0,1-6-6l.039-56a5.988,5.988,0,0,1,5.961-6h6v-8h4v8h36v-8h4v8h6a6.009,6.009,0,0,1,6,6v56A6.008,6.008,0,0,1,5689,7781Zm-58-52v48h60v-48Zm48,36h-16v-16h16v16Z",
    transform: "translate(-5551.501 -7260.501)",
    fill: "#242424"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHolidayIcon);
export default __webpack_public_path__ + "static/media/holiday_icon.c8bdb80bcab50e438ac67e6b707887ca.svg";
export { ForwardRef as ReactComponent };